let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("azyXX")).then(() => parcelRequire('dlAu1'));